
import { defineComponent, PropType, ref } from 'vue'
import {
    useEmployeeModule,
    EditEmployeePayload
} from '@/modules/employees'
import QForm from 'quasar/src/components/form/QForm.js';
import EmployeeFormFieldEmail from '@/components/employees/form-fields/email.vue'
import EmployeeFormFieldFirstName from '@/components/employees/form-fields/first-name.vue'
import EmployeeFormFieldLastName from '@/components/employees/form-fields/last-name.vue'
import EmployeeFormFieldRoles from '@/components/employees/form-fields/roles.vue'
import { EmployeeRouteNames } from '@/router/routes-names'
import { useFormModule } from '@/modules/_shared/forms'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
    name: 'employees-edit-form',
    components: { EmployeeFormFieldRoles, EmployeeFormFieldLastName, EmployeeFormFieldFirstName, EmployeeFormFieldEmail },
    props: {
        employee: {
            type: Object as PropType<EditEmployeePayload>,
            required: true
        }
    },
    emits: ['formSent'],
    setup (props) {
        const { updateEmployee } = useEmployeeModule()
        const { submitForm, createOnSuccess } = useFormModule()

        const router = useRouter()
        const route = useRoute()
        const form = ref<QForm>()
        const employeeModel = ref(props.employee)

        const sendRequest = async () => updateEmployee(employeeModel.value)
        const moveToList = () => router.push({ name: EmployeeRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Employee changed')
        ).then(moveToList)

        return {
            EmployeeRouteNames,
            onSubmit,
            employeeModel,
            form,
            route
        }
    }
})
